import { Link } from 'gatsby'
import type { ReactNode } from 'react'

type PictosHomeLinkProps = {
  to: string
  className?: string
  onClick?: () => void
  children: ReactNode
}

export function PictosHomeLink({
  to,
  className,
  onClick,
  children,
}: PictosHomeLinkProps) {
  return (
    <Link to={to} className={className} onClick={onClick}>
      {children}
    </Link>
  )
}
